// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"efaabdea","239":"fb2f27ea","453":"7bf6ce96","732":"6a0001f9"}[chunkId] + ".chunk.js";
};